/**
 * Guard para **rutas públicas de login**: impide entrar a `/auth/login` si ya hay sesión activa.
 *
 * @see AuthService.redirectIfUserIsAuth
 */

import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth.service';
import { AuthStatus } from '../models/auth.model';

export const isNotAuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);

  if (authService.authStatus() === AuthStatus.checking) {
    const updatedAuthStatus = authService.reauthenticate();

    return authService.redirectIfUserIsAuth(updatedAuthStatus);
  }

  return authService.redirectIfUserIsAuth(authService.authStatus());
};
